import {Layout, Text} from '@di-nxt/components';
import React from 'react';

type Props = {
  title: string;
  selected?: boolean;
  onSelected?: () => void;
};

export const SideBarButton: React.FC<Props> = ({
  title,
  selected = false,
  onSelected,
}) => {
  return (
    <Layout
      onPress={onSelected}
      hover
      justify="space-between"
      align="center"
      paddingHorizontal="16"
      paddingVertical="8"
      backgroundColor={
        selected ? 'background_mono_tertiary' : 'background_mono_primary'
      }>
      <Layout flex align="center" justify="space-between">
        <Text
          align="left"
          textColor="content_mono_primary"
          variant={selected ? 'paragraph_14_emphasis' : 'paragraph_14_default'}>
          {title}
        </Text>
      </Layout>
    </Layout>
  );
};
